import s from "./ghl-ui.es1505.js";
import n from "./ghl-ui.es1506.js";
import a from "./ghl-ui.es1466.js";
function i(e, t) {
  a(2, arguments);
  var r = n(e), o = s(t);
  return r.setSeconds(o), r;
}
export {
  i as default
};
